/* ===========================================================================
   MAVELY UI PLUS  v1   (MV118)  —  two additions to the public page
   ===========================================================================
   1. TASK 3 — an "opens a panel" icon on the only two image options that open
      one. The icon does not implement anything: it calls the SAME public
      entry point the option's own title already calls.

          ADD SIMPLE FRAME BORDER        window.__mvSimpleFrameApi.openPicker()
                                         (mavely-simpleframe.v1.js)
          ADD or Build Your Own Frame    window.__mvBuilder().open()
                                         (mavely-framebuilder.v1.js)

      Both files export those on purpose and mavely-frameunify already opens
      the builder through exactly that call. Nothing in either file is read,
      wrapped, copied or changed.

   2. TASK 7.1 — the Download button in the header. Label, button text,
      destination, style and visibility all come from the dashboard; see
      api/download-button.php and mavely-download-admin.v1.js.

   NOTHING EXISTING IS TOUCHED. This file adds elements and listeners of its
   own and never reassigns, wraps or re-implements a function that was already
   on the page. Remove its two tags from index.html and the site is exactly
   what it was.

   Console: __mvUiPlus()
   =========================================================================== */
(function () {
  'use strict';

  if (window.__mvUiPlusV1) return;
  window.__mvUiPlusV1 = true;

  var DOC = document;
  var stats = { icons: 0, opens: 0, dlMounts: 0, dlClicks: 0 };

  function el(tag, cls, text) {
    var n = DOC.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  /* An arrow leaving a box — the same idea as oprntab.png, drawn as a stroke
     so it inherits the button's colour in both themes. */
  var SVG_OPEN =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M14 4h6v6"/><path d="M20 4 11 13"/>' +
    '<path d="M18 14v5a1.8 1.8 0 0 1-1.8 1.8H5.8A1.8 1.8 0 0 1 4 19V7.8A1.8 1.8 0 0 1 5.8 6H11"/>' +
    '</svg>';

  var SVG_DL =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M12 3v12"/><path d="m7 11 5 5 5-5"/><path d="M4 20h16"/></svg>';

  /* =======================================================================
     1. TASK 3 — THE "OPENS A PANEL" ICON
     ======================================================================= */

  /* The two labels, exactly as the frame scripts themselves look them up.
     .mv-bd-check is the visible Build control since MV114.15; .mv-fr-check is
     the fallback for an install without mavely-frameguard. */
  function simpleLabel() { return DOC.querySelector('.mv-imgopts label.mv-sf-check'); }
  function buildLabel() {
    return DOC.querySelector('.mv-imgopts label.mv-bd-check') ||
           DOC.querySelector('.mv-imgopts label.mv-fr-check');
  }

  /** ADD SIMPLE FRAME BORDER — mavely-simpleframe's own opener. */
  function openSimple() {
    var api = window.__mvSimpleFrameApi;
    if (api && typeof api.openPicker === 'function') { api.openPicker(); return true; }
    var f = window.__mvSimpleFrame;
    if (typeof f === 'function') {
      var a = f();
      if (a && typeof a.openPicker === 'function') { a.openPicker(); return true; }
    }
    return false;
  }

  /** ADD or Build Your Own Frame Border — mavely-framebuilder's own opener,
      reached the same way mavely-frameunify reaches it, including the lazy
      load for when the frame modules have not arrived yet. */
  function openBuild() {
    var b = window.__mvBuilder;
    if (typeof b === 'function') {
      var api = b();
      if (api && typeof api.open === 'function') { api.open(); return true; }
    }
    if (typeof window.__mvLoadFrames === 'function') {
      window.__mvLoadFrames().then(function () {
        var b2 = window.__mvBuilder;
        if (typeof b2 === 'function') {
          var a2 = b2();
          if (a2 && typeof a2.open === 'function') a2.open();
        }
      });
      return true;
    }
    return false;
  }

  var OT_TITLE = {
    en: 'Opens the panel for this option',
    ar: 'يفتح لوحة هذا الخيار',
    es: 'Abre el panel de esta opción',
    fr: 'Ouvre le panneau de cette option'
  };
  function lang() {
    var l = String(DOC.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
    return OT_TITLE[l] ? l : 'en';
  }

  function addIcon(label, open) {
    if (!label) return;
    if (label.querySelector('.mv-ot-open')) return;

    var b = el('button', 'mv-ot-open');
    b.type = 'button';
    b.setAttribute('data-no-i18n', '1');
    b.setAttribute('aria-haspopup', 'dialog');
    b.title = OT_TITLE[lang()];
    b.setAttribute('aria-label', OT_TITLE[lang()]);
    b.innerHTML = SVG_OPEN;

    /* The icon sits INSIDE a <label>, and a click anywhere in a label is
       forwarded to its checkbox. preventDefault stops that forwarding, so the
       icon opens the panel without also flipping the switch — the same
       arrangement mavely-frameunify uses for the label's text. */
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      stats.opens++;
      open();
    });

    label.appendChild(b);
    stats.icons++;
  }

  function mountIcons() {
    addIcon(simpleLabel(), openSimple);
    addIcon(buildLabel(), openBuild);
  }

  /* =======================================================================
     2. TASK 7.1 — THE DOWNLOAD BUTTON
     ======================================================================= */

  /* The settings are written by the dashboard as a plain static file at the
     web root, exactly the way mavely-subdomain writes /mv-subdomains.json:
     the web server hands it out by itself and answers 304 when it has not
     changed, so a visitor costs no PHP at all. api/download-button.php is
     only asked when the static copy is missing. */
  var PUBLIC_FILE = '/mv-download-button.json';
  var API = '/api/download-button.php';

  var cfg = null;

  function normalise(j) {
    j = j && typeof j === 'object' ? j : {};
    var url = String(j.url || '').trim();
    /* Only http(s) ever becomes an href. A javascript: or data: value saved
       by accident is dropped rather than rendered. */
    if (url && !/^https?:\/\//i.test(url)) url = '';
    return {
      enabled: j.enabled === true || j.enabled === 1 || j.enabled === '1',
      label: String(j.label === undefined || j.label === null ? 'DOWNLOAD :' : j.label),
      text: String(j.text || 'Download').trim() || 'Download',
      url: url,
      style: j.style === 'simple' ? 'simple' : 'shiny'
    };
  }

  function loadCfg() {
    return fetch(PUBLIC_FILE, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(0); })
      .catch(function () {
        return fetch(API, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (j) {
        cfg = normalise(j && j.settings ? j.settings : j);
        return cfg;
      })
      .catch(function () { cfg = normalise(null); return cfg; });
  }

  function headerRow() { return DOC.querySelector('.mv-rd-head-in'); }

  function mountDownload() {
    if (!cfg) return;
    var row = headerRow();
    if (!row) return;

    var wrap = row.querySelector('.mv-dl-wrap');

    /* Switched off, or no destination set yet: nothing on the page at all. */
    if (!cfg.enabled || !cfg.url) {
      if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
      return;
    }

    if (!wrap) {
      wrap = el('div', 'mv-dl-wrap');
      wrap.setAttribute('data-no-i18n', '1');

      var lab = el('span', 'mv-dl-label');
      lab.setAttribute('data-no-i18n', '1');
      wrap.appendChild(lab);

      /* A real link with target="_blank", not a scripted window.open: a popup
         blocker never stops it, middle-click and "open in new tab" work, and
         rel="noopener" keeps the new tab off window.opener. */
      var a = DOC.createElement('a');
      a.className = 'mv-dl-btn';
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.setAttribute('data-no-i18n', '1');
      a.innerHTML = SVG_DL;
      a.appendChild(el('span', 'mv-dl-text'));
      a.addEventListener('click', function () { stats.dlClicks++; });
      wrap.appendChild(a);

      /* Straight after the logo link, so it reads
         [logo] [DOWNLOAD :] [button] … [socials] [languages] */
      var logo = row.querySelector('a[href="/"]') || row.firstElementChild;
      if (logo && logo.nextSibling) row.insertBefore(wrap, logo.nextSibling);
      else row.appendChild(wrap);
      stats.dlMounts++;
    }

    var labEl = wrap.querySelector('.mv-dl-label');
    var btn = wrap.querySelector('.mv-dl-btn');
    var txt = wrap.querySelector('.mv-dl-text');

    if (labEl) {
      labEl.textContent = cfg.label;
      labEl.style.display = cfg.label.trim() ? '' : 'none';
    }
    if (txt && txt.textContent !== cfg.text) txt.textContent = cfg.text;
    if (btn) {
      if (btn.getAttribute('href') !== cfg.url) btn.setAttribute('href', cfg.url);
      btn.title = cfg.text;
      var want = 'mv-dl-btn ' + (cfg.style === 'simple' ? 'mv-dl-simple' : 'mv-dl-shiny');
      if (btn.className !== want) btn.className = want;
    }
  }

  /** The dashboard calls this after a save so the page updates without F5. */
  function applyCfg(next) {
    cfg = normalise(next);
    mountDownload();
  }

  /* =======================================================================
     PASSES
     ======================================================================= */

  function pass() {
    try { mountIcons(); } catch (e) {}
    try { mountDownload(); } catch (e) {}
  }

  function boot() {
    pass();
    loadCfg().then(pass);

    if (!window.MutationObserver) return;
    /* One rAF-debounced pass, the same shape mavely-simpleframe uses. Each
       pass only ADDS what is missing, so the observer settles immediately
       instead of re-triggering itself. */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      (window.requestAnimationFrame || window.setTimeout)(function () {
        pending = false;
        pass();
      });
    }).observe(DOC.documentElement, { childList: true, subtree: true });
  }

  if (DOC.readyState === 'loading') DOC.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.__mvUiPlus = function () {
    return {
      stats: stats,
      download: cfg,
      icons: {
        simple: !!(simpleLabel() && simpleLabel().querySelector('.mv-ot-open')),
        build: !!(buildLabel() && buildLabel().querySelector('.mv-ot-open'))
      },
      openSimple: openSimple,
      openBuild: openBuild,
      reload: function () { return loadCfg().then(pass); }
    };
  };

  /* how the dashboard pushes a change into the live page */
  window.__mvUiPlusApply = applyCfg;
})();
